import { render, staticRenderFns } from "./FormViewRun2.vue?vue&type=template&id=630864f0&scoped=true"
import script from "./FormViewRun2.vue?vue&type=script&lang=js"
export * from "./FormViewRun2.vue?vue&type=script&lang=js"
import style0 from "./FormViewRun2.vue?vue&type=style&index=0&id=630864f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630864f0",
  null
  
)

export default component.exports